import { Component } from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { AbstractInputListaDadComponent, mapValueTypeAbstractInputListaDadComponent } from "@app/shared/directive/abstract-input-lista-dad.component.directive";
import { AttoVO } from "@app/shared/vo/attoVO";
import { ListaDadItem, ListaDadItemChild } from "../lista-dad/lista-dad.component";
import { moveItemInArray } from "@angular/cdk/drag-drop";


@Component({
	selector: "app-input-atti-dad",
	templateUrl: "./input-atti-dad.component.html",
	providers: [InputAttiDadComponent.provider]
})
export class InputAttiDadComponent extends AbstractInputListaDadComponent<AttoVO> {

	constructor(
		protected controlContainer: ControlContainer
	) {
		super();
		this.setRowGroupKey("settore.codice");
		this.setRowIdKey("id");
	}

	protected getGroupName(item: AttoVO, rowGroupKeyValue?: string) {
		return [item.settore.codice, item.settore.nome].join(" - ");
	}

	protected getMainGroupName(): string {
		return "Decreti con visto contabile";
	}

	protected assignGroupToListaDad(
		groupMap: Map<string, mapValueTypeAbstractInputListaDadComponent<AttoVO>>,
		listaDad: ListaDadItem<AttoVO>
	): void {
		groupMap.forEach((group) => {
			listaDad.addChildren(group.list);
		});
	}
	onCheckChange(item: ListaDadItemChild<AttoVO>) {
		if (item && item.index !== undefined && item.parent && item.parent.children && item.parent.children.length > 0) {
			let index: number;
			if(item.checked){
				index = item.parent.children.findIndex(item2 => item2.dragDisabled === true);
				index = index < 0 ? item.parent.children.length - 1 : index;
			}else{
				index = item.parent.children.length - 1;
			}
			

			if (item.elem instanceof ListaDadItem) {
				item.elem.moveItemInArray(index);
				item.elem.toggleDisable();
			} else {
				item.dragDisabled = !item.checked;
				moveItemInArray(item.parent.children, item.index, index);
				for(let i=Math.min(item.index, index); i < item.parent.children.length; i++){
					item.parent.children[i].index = i;
				}
			}
		}
	}
	afterDragDrop(item: ListaDadItemChild<AttoVO>){
		if (item && item.checked && item.index !== undefined && item.parent && item.parent.children && item.parent.children.length > 0) {
			let index:number = item.parent.children.findIndex(item2 => item2.dragDisabled === true);
			index = index < 0 ? item.parent.children.length - 1 : index;
			if(index < item.index){
				if (item.elem instanceof ListaDadItem) {
					item.elem.moveItemInArray(index);
					item.elem.toggleDisable();
				} else {
					item.dragDisabled = !item.checked;
					moveItemInArray(item.parent.children, item.index, index);
					for(let i=Math.min(item.index, index); i < item.parent.children.length; i++){
						item.parent.children[i].index = i;
					}
				}
			}			

			
		}
	}
	
}